import React, { useEffect, useState } from "react";

const ProfileList = ({ interests, currentUser, onTopMatches }) => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const interestParam = encodeURIComponent(interests || "");
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/projects/admin/match-profiles?interests=${interestParam}&email=${currentUser.email}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();

        if (!res.ok) {
          console.error("❌ Error:", data.message);
          setProfiles([]);
        } else {
          const rawProfiles = data.topMatches || [];

          // ✅ Deduplicate by email
          const seen = new Set();
          const uniqueProfiles = rawProfiles.filter((user) => {
            if (!user.email) return false;
            const email = user.email.toLowerCase();
            if (seen.has(email)) return false;
            seen.add(email);
            return true;
          });

          setProfiles(uniqueProfiles);

          // ✅ Only now call onTopMatches
          if (onTopMatches) {
            onTopMatches(uniqueProfiles);
          }
        }
      } catch (err) {
        console.error("❌ Network error:", err);
        setProfiles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, [interests, currentUser.email, token, onTopMatches]);

  return (
    <div>
      <h3 className="text-sm font-medium mb-2 text-gray-700">🧑‍🤝‍🧑 Find People</h3>

      {loading ? (
        <p className="text-xs text-gray-400">Loading profiles...</p>
      ) : profiles.length === 0 ? (
        <p className="text-xs text-gray-400">No similar profiles found.</p>
      ) : (
        <ul className="space-y-2 mb-4">
          {profiles.map((user, index) => {
            const interestList = Array.isArray(user.interests)
              ? user.interests.slice(0, 3).join(", ")
              : user.interests;

            return (
              <li
                key={user.email || index}
                className="bg-white border p-3 rounded flex items-center space-x-3"
              >
                <img
                  src={user.avatar || "/person.png"}
                  alt={`${user.firstName}'s avatar`}
                  className="w-10 h-10 rounded-full object-cover border border-gray-300"
                />
                <div>
                  <p className="text-sm font-semibold text-blue-700">
                    {user.firstName} {user.lastName}
                  </p>
                  <p className="text-xs italic text-gray-600 mb-1">{interestList}</p>
                  <p className="text-xs text-green-600 font-medium">
                    {user.matchScore}% match
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ProfileList;
